import React, { useMemo, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Tabs from "components/lib/Shared/Tabs";
import { useSelector } from "react-redux";
import StakeholderDetails from "components/TransactionReviewTab/CompanyOfficials/StakeholderDetails";

const TransactionSignatureTab = () => {
  const { getTransactionUnderReview } = useSelector(
    (state) => state.transactionSlice
  );

  const params = useParams();
  const initialTabs = useMemo(() => {
    let tempTabs = [
      {
        id: "companyOfficial",
        label: "Company Official Signature",
      },
    ];
    tempTabs = tempTabs.filter(Boolean); // Remove any falsy values (like empty strings)
    return tempTabs;
  }, []);
  const [tabs, setTabs] = useState(initialTabs);
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);
  const [selectedTab, setSelectedTab] = useState(tabs[selectedTabIndex]);

  useEffect(() => {
    setSelectedTab(tabs[selectedTabIndex]);
  }, [selectedTabIndex]);

  return (
    <div>
      <div>
        <Tabs
          tabs={tabs}
          selectedTabIndex={selectedTabIndex}
          setSelectedTabIndex={setSelectedTabIndex}
          showBorderBottom={false}
        />
      </div>
      <div>
        {selectedTab.id === "companyOfficial" && (
          <div>
            <StakeholderDetails isChangesSignature={true} />
          </div>
        )}
      </div>
    </div>
  );
};

export default TransactionSignatureTab;
